import { Component } from '@angular/core';
import { IonCard, IonCardContent, IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-skeleton-card-generic',
  templateUrl: './skeleton-card-generic.component.html',
  styleUrls: ['./skeleton-card-generic.component.scss'],
  imports: [IonSkeletonText, IonCol, IonRow, IonGrid, IonCardContent, IonCard],
})
export class SkeletonCardGenericComponent {
  // constructor() {}
}
